import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Flex } from "rebass";
import { systemActions, yodaStakeholderActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import InfoMobile from "../../icons/InfoMobile";
import Close from "../../icons/Close";
import Shipping from "../../icons/Shipping";
import LatestOrders from "../../icons/LatestOrders";
import { Price } from "./Price";
import { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { PreLoader } from "../loader/PreLoader";
import { getLocalizedText } from "../../utils/getLocalizedText";
import { IoIosAlert } from "react-icons/io";

const InfoButton = ({ sx, ...props }) => {
  const dispatch = useDispatch();

  const { orderId } = useParams();

  const { activeNavButton } = useSelector((state) => state.system);
  const { orderHistoryNewCount } = useSelector(
    (state) => state.yodaStakeholders,
  );

  const [active, setActive] = useState("orders");

  const tabs = useMemo(
    () => [
      {
        id: "orders",
        icon: LatestOrders,
        content: <OrderHistoryTab />,
      },
      ...(orderId
        ? [
            {
              id: "shipping",
              icon: Shipping,
              content: <ShippingCostsTab />,
            },
          ]
        : []),
    ],
    [orderId],
  );

  return (
    <Box>
      {/* button */}
      <Flex
        sx={{
          width: ["36px", , , "40px"],
          height: "50px",
          alignItems: ["center", "flex-start"],
          justifyContent: "center",
          cursor: "pointer",
          borderTop: ["none", "10px solid #232323"],
          paddingTop: [0, "4px"],
          ...(activeNavButton === "info" && {
            backgroundColor: ["#a2a2a2", "#fff"],
            color: ["#fff", "#232323"],
            paddingTop: 0,
          }),
          ...sx,
        }}
        onClick={() => {
          dispatch(
            systemActions.toggleMobileNavButton(
              activeNavButton === "info" ? null : "info",
            ),
          );
        }}
        {...props}
      >
        {!(activeNavButton === "info") && (
          <Box sx={{ height: 24, width: 24, position: "relative" }}>
            <InfoMobile style={{ height: 24, width: 24 }}></InfoMobile>
            {orderHistoryNewCount > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                <IoIosAlert
                  style={{
                    width: 16,
                    height: 16,
                    transform: "scale(1.3)",
                  }}
                  color="#f04836"
                />
              </Box>
            )}
          </Box>
        )}
        {activeNavButton === "info" && <Close style={{ width: 20 }}></Close>}
      </Flex>
      {/* modal gu*/}
      {activeNavButton === "info" && (
        <Flex
          width={["100%", "400px"]}
          height={`calc(100dvh - 50px)`}
          maxHeight={[`calc(100dvh - 50px)`, "525px"]}
          sx={{
            position: "absolute",
            zIndex: 2,
            backgroundColor: "#232323",
            right: 0,
            marginTop: 0,
            color: "#fff",
            padding: "8px",
            borderTop: "2px solid",
            zIndex: 9999,
            borderColor: ["#a2a2a2", "#fff"],
          }}
          flexDirection={"column"}
          alignItems={"center"}
        >
          <Flex
            width={"100%"}
            height={"100%"}
            flexDirection={"column"}
            alignItems={"center"}
          >
            <InfoButtonTabs {...{ tabs, active, setActive }} />
            {/* {!!customer?.id &&
              !location.pathname?.includes(`orders/${customer.id}`) && (
                <Button
                  sx={{
                    width: "100%",
                    background: "#fff",
                    textTransform: "uppercase",
                    fontWeight: 600,
                    padding: "8px",
                    marginTop: "20px",
                    color: "black",
                    fontSize: "1.2em",
                  }}
                  onClick={() => {
                    history.push("/orders/" + customer.id);
                  }}
                >
                  {getLocalizedString("INFO_BUTTON_GO_TO_ORDERS_CTA")}
                </Button>
              )} */}
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

const InfoButtonTabs = ({ tabs, active, setActive, sx, ...props }) => {
  return (
    <Flex
      sx={{
        height: "100%",
        position: "relative",
        width: "100%",
        flexDirection: "column",
        gap: "20px",
        overflow: "hidden",
        ...sx,
      }}
      {...props}
    >
      <Flex
        sx={{
          width: "100%",
          borderBottom: "2px solid #fff",
          background: "#232323",
          color: "#fff",
          padding: "0 4px",
        }}
      >
        {tabs.map((tab, index) => {
          const isActive = active === tab.id;
          return (
            <Button
              key={`infoButtonTabs-${index}-${tab.id}`}
              sx={{
                ...(isActive && {
                  background: "#fff",
                  color: "black",
                  borderRadius: 0,
                }),
              }}
              onClick={() => setActive(tab.id)}
            >
              <Box
                sx={{
                  transform: "scale(0.8)",
                }}
              >
                <tab.icon {...(!isActive && { color: "#fff" })} />
              </Box>
            </Button>
          );
        })}
      </Flex>
      <Box
        sx={{
          height: "50vh",
          flex: 1,
          overflowY: "auto",
        }}
      >
        {tabs.find((tab) => tab.id === active).content}
      </Box>
    </Flex>
  );
};

const ShippingCostsTab = () => {
  const { budget } = useSelector((state) => state.yodaBudget);
  return (
    <Box sx={{ width: "100%", paddingLeft: "4px" }}>
      <Box style={{ fontSize: "1.5em" }} width={"85%"}>
        {getLocalizedString("FIRST ROW INFO")}{" "}
        <Price style={{ display: "inline" }} price={budget?.shippingCost} />
      </Box>
      <Box style={{ fontSize: "1.1em" }} width={"85%"}>
        {getLocalizedString("SECOND ROW INFO")}{" "}
        <Price style={{ display: "inline" }} price={budget?.minAmount} />
      </Box>
      {budget?.minOrderDetails[0]?.id == 2 ||
      budget?.minOrderDetails[1]?.id == 2 ? (
        <Box style={{ fontSize: "0.8em" }} width={"85%"}>
          {budget?.minOrderDetails[0]?.id == 2 ? (
            <Price
              style={{
                display: "inline",
              }}
              price={budget.minOrderDetails[0].minAmount}
            />
          ) : (
            <Price
              style={{
                display: "inline",
              }}
              price={budget.minOrderDetails[1].minAmount}
            />
          )}
          {getLocalizedString("THIRD ROW INFO")}
        </Box>
      ) : null}
    </Box>
  );
};

const OrderHistoryTab = () => {
  const dispatch = useDispatch();
  const { orderHistory, loading } = useSelector(
    (state) => state.yodaStakeholders,
  );

  useEffect(() => {
    dispatch(yodaStakeholderActions.getOrderHistory());
    return () => {
      dispatch(yodaStakeholderActions.getOrderHistoryNewCount());
    };
  }, []);

  return (
    <Flex
      sx={{
        width: "100%",
        flexDirection: "column",
        gap: "5px",
        position: "relative",
      }}
    >
      {!loading &&
        orderHistory.map((order, index) => (
          <OrderHistoryItem
            key={`order-history-item-${index}-${order?.id}`}
            {...{ order }}
          />
        ))}
      {!!loading && (
        <Flex
          justifyContent={"center"}
          alignContent={"center"}
          sx={{ width: "100%", py: "10px" }}
        >
          <PreLoader color="#fff" size="md" />
        </Flex>
      )}
    </Flex>
  );
};

const OrderHistoryItem = ({ order }) => {
  const fields = [
    {
      id: "orderNumber",
      label: getLocalizedString("ORDER_HISTORY_ITEM_ORDER_NUMBER"),
      value: order?.orderNumber || "",
    },
    {
      id: "user",
      label: getLocalizedString("ORDER_HISTORY_ITEM_ORDER_USER"),
      value: order?.updatedby || "",
    },
    {
      id: "CUSTOMER",
      label: getLocalizedString("ORDER_HISTORY_ITEM_ORDER_CUSTOMER"),
      value: order?.customerCode || "",
    },
    {
      id: "date",
      label: getLocalizedString("ORDER_HISTORY_ITEM_ORDER_DATE"),
      value: order?.dateFe || "",
    },
  ];

  return (
    <Flex
      sx={{
        width: "100%",
        gap: "10px",
        alignItems: "flex-start",
        borderBottom: "1px solid #a2a2a2",
        padding: "8px",
        ...(order?.isViewed === false && {
          background: "#454545",
        }),
      }}
    >
      <Box
        sx={{
          background: order?.operationColor || "transparent",
          width: "12px",
          height: "12px",
          borderRadius: "6px",
          marginTop: "7px",
        }}
      />
      <Box width="100%">
        <Box
          sx={{
            textTransform: "uppercase",
            fontSize: "1.5em",
            fontWeight: 600,
          }}
        >
          {getLocalizedText(JSON.parse(order?.operationDescription))}
        </Box>
        <Flex
          sx={{
            flexFlow: "row wrap",
            width: "100%",
          }}
        >
          {fields.map((field) => (
            <Flex
              key={`order-history-item-${order?.id}-${field?.id}`}
              sx={{
                width: "50%",
                padding: "0 4px 4px 0",
                color: "#cfd1cf",
                flexFlow: "row wrap",
              }}
            >
              <Box marginRight={"4px"}>{field.label}:</Box>
              <Box sx={{ fontWeight: 600, textTransform: "uppercase" }}>
                {field.value}
              </Box>
            </Flex>
          ))}
        </Flex>
      </Box>
    </Flex>
  );
};

export default InfoButton;
